import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import Icon from "./Icon";
import { productLabel } from "./ProductActions";
import { statusOf } from "./catalogModel";

const MAX_LISTED = 4;

/**
 * Confirms activating or deactivating one or more products. Activation only proceeds for verified products and
 * deactivation only for active ones; the rest are counted as skipped so a bulk selection can be mixed.
 */
export default function ConfirmStatusDialog({ request, environment, onClose, onConfirm }) {
  const open = !!request;
  const activate = request?.mode === "activate";
  const eligibleStatus = activate ? "verified" : "active";
  const all = request?.products || [];
  const eligible = all.filter((p) => statusOf(p) === eligibleStatus);
  const skipped = all.length - eligible.length;
  const one = eligible.length === 1 ? eligible[0] : null;
  const verb = activate ? "Activate" : "Deactivate";
  const title = one ? `${verb} ${one.name}${one.edition ? ` ${one.edition}` : ""}?` : `${verb} ${eligible.length} products?`;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <div className="ac-root ac-dlg">
          <div className="ac-dlg-list">
            {eligible.slice(0, MAX_LISTED).map((p) => (
              <div key={p.key}><span>{productLabel(p)}</span><span className="mono">{p.environment?.productNumber}</span></div>
            ))}
            {eligible.length > MAX_LISTED && <div className="more">and {eligible.length - MAX_LISTED} more</div>}
          </div>
          <ul className="ac-impact">
            <li><Icon n="users" s={15} /><span>
              {activate
                ? `Confirm you have compared the product number with AHA's documentation for ${environment}. Once active, coordinators at every training center can pick it and cards will be sent to AHA under this number.`
                : `Removed from the Create Course list for every training center. Existing classes keep their product.`}
            </span></li>
            <li><Icon n="server" s={15} /><span>Changes apply to AHA {environment} only and are audit-logged.</span></li>
          </ul>
          {skipped > 0 && (
            <p className="ac-skip"><Icon n="alert" s={14} />
              {skipped} selected product{skipped > 1 ? "s are" : " is"} not {activate ? "verified" : "active"} and will be skipped.
            </p>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" disableElevation disabled={eligible.length === 0} onClick={() => onConfirm(request.mode, eligible)}>
          {verb} product{eligible.length === 1 ? "" : "s"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
